import SRGame from "./SRGame";

var game = new SRGame();